import React from 'react';
import { createTheming, createUseStyles as jssCreateUseStyles } from 'react-jss';
import { Classes, Styles, StyleSheetFactoryOptions } from 'jss';
import { Theming } from 'theming';

interface BaseOptions<T> extends StyleSheetFactoryOptions {
  index?: number;
  theming?: Theming<T>;
}

interface CreateUseStylesOptions<T> extends BaseOptions<T> {
  name?: string;
}

export default function createTheme<Theme>(theme: Theme) {
  const ThemeContext = React.createContext(theme);

  const theming = createTheming(ThemeContext);

  const { ThemeProvider, useTheme } = theming;

  function createUseStyles<C extends string = string>(
    styles: Styles<C> | ((theme: Theme) => Styles<C>),
    options?: CreateUseStylesOptions<Theme>
  ): (data?: unknown) => Classes<C> {
    return jssCreateUseStyles(styles, { theming, ...options });
  }

  return { ThemeProvider, createUseStyles, useTheme };
}
